// extracted by mini-css-extract-plugin
export default {"raychat_logo":"styles_raychat_logo__vq-7I"};